<template>
    <div>
        <div class="row justify-content-center">
            <div>
                <h4 v-if="date">{{ $t(esReservaInstalaciones ? 'eventos.calendario_fecha_reserva' : 'eventos.calendario_fecha') }} {{ dateText }}</h4>
                <h4 v-else>{{ $t('eventos.calendario_seleccione_dia') }}</h4>
            </div>
        </div>
        <div class="row justify-content-center mt-4">
            <vc-date-picker mode="date" v-model="date" :attributes="attributes" :model-config="modelConfig"
                            :available-dates="available" @dayclick="getSesiones" ref="calendar"
            />
        </div>
        <ListadoSessiones v-if="sesiones.length > 0" :event="event" :sesiones="sesiones" :productos="false"/>
    </div>

</template>

<script>
    import ListadoSessiones from '@/components/frontend/events/ListadoSessiones';
    import { TEATRO_HASH_RESERVA_INSTALACIONES } from '@/constants/teatros';
    export default {
        props: ['event'],
        data() {
            return {
                date: null,
                modelConfig: {
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                },
                sesiones: [],
            }
        },
        mounted() {
            this.getPrimerDate();
        },
        computed: {
            esReservaInstalaciones() {
                return this.$store.getters.getTeatro?.hash === TEATRO_HASH_RESERVA_INSTALACIONES;
            },
            attributes() {
                var data = [
                    {
                        dates: [],
                    },
                    {
                        dates: [],
                    }
                ]

                const sesionesPorDia = this.event.sesiones.reduce((acc, sesion) => {
                    const fecha = moment(sesion.session_date).format('YYYY-MM-DD');
                    if (!acc[fecha]) {
                        acc[fecha] = [];
                    }
                    acc[fecha].push(sesion);
                    return acc;
                }, {});

                Object.entries(sesionesPorDia).forEach(([fecha, sesiones]) => {
                    const todasSinEntradas = sesiones.every(sesion => !sesion.entradas_libres);
                    const tieneEntradas = sesiones.some(sesion => sesion.entradas_libres);

                    if (tieneEntradas) {
                        data[0].dates.push(new Date(fecha));
                        data[0].popover = { label: 'Hay sesiones disponibles' };
                        data[0].dot = { color: 'green' };
                    }

                    if (todasSinEntradas) {
                        data[1].dates.push(new Date(fecha));
                        data[1].popover = { label: 'No hay sesiones disponibles' };
                        data[1].dot = { color: 'red' };
                    }
                });

                data[1].dates = data[1].dates.filter(
                    date1 => !data[0].dates.some(date2 => moment(date1).isSame(date2, 'day'))
                );

                return data;
            },
            available() {
                var data = []

                this.event.sesiones.forEach(sesion => {
                    data.push({
                        start: new Date(sesion.session_date),
                        end: new Date(sesion.session_date)
                    })
                });
                return data
            },
            dateText() {
                var fecha = new Date(this.date);
                var dia = fecha.getDate();
                var mesNumero = fecha.getMonth();

                // Crear un arreglo de nombres de meses
                var meses = [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Diciembre"
                ];

                // Obtener el mes en texto
                var mesTexto = meses[mesNumero];

                // Obtener el año (número)
                var ano = fecha.getFullYear();

                return dia + " de " + mesTexto + " de " + ano;
            },
        },
        methods: {
            getSesiones() {
                this.sesiones = [];
                var fecha = new Date(this.date);
                const inicioDelDia = fecha.setHours(0, 0, 0, 0);
                const finalDelDia = fecha.setHours(23, 59, 59, 999);

                this.event.sesiones.forEach(sesion => {
                    if (new Date(sesion.session_date) >= new Date(inicioDelDia) && new Date(sesion.session_date) <= new Date(finalDelDia)) {
                        this.sesiones.push(sesion)
                    }
                });
            },
            getPrimerDate(){
                var fecha = moment(this.event.sesiones[0].session_date);

                var mes = parseInt(fecha.format('M'));
                var ano = parseInt(fecha.format('YYYY'));

                const calendar = this.$refs.calendar
                calendar.move({ month: mes, year: ano })
            }
        },
        components: { ListadoSessiones }
    }

</script>

<style scoped>
.vc-container {
    width: 48vw;
    margin-bottom: 32px;
    border: 2px solid darkgray;
}

@media (max-width: 1024px) {
    .vc-container {
        width: 76vw; 
    }
}

@media (max-width: 768px) {
    .vc-container {
        width: 88vw; 
    }
}
</style>